import WorkspaceSelector from '../components/WorkspaceSelector'
import { connect } from 'react-redux'
import {
  createWorkspace,
  fetchWorkspacesIfNeeded
} from '../actions/workspaceActions'
import ProTooltip from '../components/ProTooltip'
import { ThemeProvider } from 'emotion-theming'
import normalizeTheme from '../utils/normalizeTheme'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import ReactDOM from 'react-dom'

@connect(
  mapStateToProps,
  { createWorkspace, fetchWorkspacesIfNeeded },
  mergeProps
)
export default class WorkspaceSelectorContainer extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    company: PropTypes.object.isRequired,
    createWorkspace: PropTypes.func.isRequired,
    fetchWorkspacesIfNeeded: PropTypes.func.isRequired,
    isFetching: PropTypes.bool.isRequired,
    isLiteUser: PropTypes.bool.isRequired,
    isSaving: PropTypes.bool.isRequired,
    onAddToWorkspace: PropTypes.func.isRequired,
    projectGroupId: PropTypes.number,
    projectId: PropTypes.number,
    workspaces: PropTypes.array.isRequired
  }

  constructor(props) {
    super(props)

    this.close = this.close.bind(this)
    this.onSaveClick = this.onSaveClick.bind(this)

    this.state = {
      isOpen: false,
      selectedWorkspaceName: '',
      isLiteUser: this.props.isLiteUser,
      offset: 0
    }
  }

  componentDidMount() {
    document.addEventListener('click', this.close)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.close)
  }

  componentWillMount() {
    const { company, fetchWorkspacesIfNeeded } = this.props
    fetchWorkspacesIfNeeded(company)
  }

  componentWillUpdate() {
    const { offset } = this.state
    const currentOffset = ReactDOM.findDOMNode(this).offsetHeight
    if (offset !== currentOffset) {
      this.setState({ offset: currentOffset })
    }
  }

  close() {
    this.setState({
      isOpen: false,
      selectedWorkspaceName: ''
    })
  }

  onSaveClick() {
    let promise
    const { selectedWorkspaceName } = this.state
    const {
      company,
      createWorkspace,
      onAddToWorkspace,
      workspaces
    } = this.props
    const selectedWorkspace = workspaces.find(workspace => {
      return (
        workspace.name.toLowerCase() ===
        selectedWorkspaceName.toLowerCase().trim()
      )
    })

    if (selectedWorkspace) {
      promise = onAddToWorkspace(selectedWorkspace)
    } else {
      promise = createWorkspace(company, { name: selectedWorkspaceName }).then(
        action => {
          const workspaceId = action.response.result
          return onAddToWorkspace(
            action.response.entities.workspaces[workspaceId]
          )
        }
      )
    }

    if (promise && typeof promise.then === 'function') {
      promise.then(() => this.close())
    } else {
      this.close()
    }
  }

  handleLinkClick = () => {
    const { isOpen, isLiteUser } = this.state

    if (!isLiteUser) {
      this.setState({ isOpen: !isOpen })
    }
  }

  renderWorkspaceSelector = () => {
    const { isFetching, isSaving, children, workspaces } = this.props
    const { isOpen, selectedWorkspaceName } = this.state

    return (
      <WorkspaceSelector
        isFetching={isFetching || isSaving}
        isOpen={isOpen}
        onLinkClick={this.handleLinkClick}
        onSaveClick={this.onSaveClick}
        onChangeSelectedWorkspace={name =>
          this.setState({ selectedWorkspaceName: name })
        }
        selectedWorkspaceName={selectedWorkspaceName}
        workspaces={workspaces}
      >
        {children}
      </WorkspaceSelector>
    )
  }

  render() {
    const { isLiteUser } = this.state

    if (isLiteUser) {
      return (
        <ThemeProvider theme={normalizeTheme()}>
          <ProTooltip
            renderTrigger={{ InternalComponent: this.renderWorkspaceSelector }}
            tooltipType="WORKSPACE"
            position="bottom"
            key={this.state.offset}
          />
        </ThemeProvider>
      )
    }

    return this.renderWorkspaceSelector()
  }
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  const {
    company,
    isFetching,
    isSaving,
    workspaceEntities,
    workspaceIds
  } = stateProps
  const workspaces = workspaceIds.map(id => workspaceEntities[id])

  return Object.assign({}, dispatchProps, ownProps, {
    company,
    isFetching,
    isSaving,
    workspaces
  })
}

function mapStateToProps(state) {
  return {
    company: state.company,
    isFetching: state.workspaces.isSaving,
    isSaving: state.workspaces.isFetching,
    workspaceEntities: state.entities.workspaces,
    workspaceIds: state.workspaces.items
  }
}



// WEBPACK FOOTER //
// ../src/containers/WorkspaceSelectorContainer.js